export const RELIGION_OPTIONS = [
  { value: 'buddhist', label: 'Buddhist' },
  { value: 'catholic', label: 'Catholic' },
  { value: 'christian', label: 'Christian' },
  { value: 'confucius', label: 'Confucius' },
  { value: 'free_thinker', label: 'Free Thinker' },
  { value: 'hindu', label: 'Hindu' },
  { value: 'muslim', label: 'Muslim' },
  { value: 'unknown', label: 'Unknown' },
  { value: 'information_not_obtained', label: 'Information Not Obtained' },
];

export const RELIGION_DISPLAY = {
  buddhist: 'Buddhist',
  catholic: 'Catholic',
  christian: 'Christian',
  confucius: 'Confucius',
  free_thinker: 'Free Thinker',
  hindu: 'Hindu',
  muslim: 'Muslim',
  unknown: 'Unknown',
  information_not_obtained: 'Information Not Obtained',
  // Legacy stored values (pre-remap)
  buddhism: 'Buddhist',
  christianity: 'Christian',
  hinduism: 'Hindu',
  islam: 'Muslim',
  sikhism: 'Unknown',
  taoism: 'Unknown',
  others: 'Unknown',
  no_religion: 'Free Thinker',
  not_disclosed: 'Information Not Obtained',
  catholicism: 'Catholic',
};

export const RELIGION_DEFAULT = 'information_not_obtained';
